module.exports = __webpack_public_path__ + "static/media/p_frv_mobile_3.5ddac74d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Pcg/p_frv_mobile_3.jpg
// module id = 541
// module chunks = 0